// extracted by mini-css-extract-plugin
export var contentWrap = "Banner-module--contentWrap--ILdSq";
export var infoBanner = "Banner-module--infoBanner--WB+X6";
export var infoBannerText = "Banner-module--infoBannerText--sT2vR";
export var infoBannerWrap = "Banner-module--infoBannerWrap--omn8W";
export var innerWrap = "Banner-module--innerWrap--Wf+Lf";
export var label = "Banner-module--label--oVdDE";
export var refreshButton = "Banner-module--refreshButton--yBBL2";
export var sticky = "Banner-module--sticky--12U-8";